/* unplugin-vue-components disabled */import { render } from "./AdultComics.vue?vue&type=template&id=0508c87a&scoped=true"
import script from "./AdultComics.vue?vue&type=script&lang=js"
export * from "./AdultComics.vue?vue&type=script&lang=js"

import "./AdultComics.vue?vue&type=style&index=0&id=0508c87a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0508c87a"]])

export default __exports__